import styled from "styled-components";
import { HorizontalMain } from "../../style/default";

export const MyHorizontalScrollView = styled(HorizontalMain)`
	justify-content: space-between;
	padding: 1rem;
	> div {
		padding: 0.1rem;
		margin-left: 0.5rem;
		display: flex;
		align-items: center;

		> input {
			min-height: 38px;
			padding: 2px 8px;
			border-color: hsl(0, 0%, 80%) !important;
			margin-left: 1rem;
			-moz-appearance: textfield;
			&::-webkit-inner-spin-button,
			&::-webkit-outer-spin-button {
				-webkit-appearance: none;
				margin: 0;
			}
			&:focus {
				box-shadow: none;
				border-color: #2684ff !important;
			}
		}
		> div {
			width: 100%;
		}
		> div:not(:first-child) {
			margin-left: 1rem;
		}
	}
`;

export const ContainerCheckbox = styled.label`
	display: block;
	position: relative;
	cursor: pointer;
	font-size: 22px;
	user-select: none;

	/* Hide the browser's default checkbox */
	> input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

	/* Create a custom checkbox */
	> .checkmark {
		position: absolute;
		top: 0;
		left: 0;
		height: 17px;
		width: 17px;
		background-color: #eee;
		left: 50%;
		transform: translateX(-50%);
	}

	/* On mouse-over, add a grey background color */
	&:hover input ~ .checkmark {
		background-color: #ccc;
	}

	/* When the checkbox is checked, add a blue background */
	> input:checked ~ .checkmark {
		background-color: #4dae51;
	}

	/* Create the checkmark/indicator (hidden when not checked) */
	> .checkmark:after {
		content: "";
		position: absolute;
		display: none;
	}

	/* Show the checkmark when checked */
	> input:checked ~ .checkmark:after {
		display: block;
	}

	/* Style the checkmark/indicator */
	> .checkmark:after {
		left: 6px;
		top: 3px;
		width: 5px;
		height: 10px;
		border: solid white;
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}
`;

export const StickyButtonFooter = styled.div`
	width: 100%;
	position: fixed;
	bottom: 0;
	background-color: #efefef;
	box-shadow: 0 0 10px #d8d6d6;

	z-index: 2;

	padding: 15px;

	display: flex;

	> button {
		margin: 0 5px;
	}
`;
